# load all blocks

# regenerate with `yarn run regenerate-blocks-index`
# everything below the next line is generated
##
require './artboard-block'
require './button-block'
require './checkbox-block'
require './file-input-block'
require './grid-block'
require './image-block'
require './instance-block'
require './layout-block'
require './line-block'
require './multistate-block'
require './non-component-multistate-block'
require './oval-block'
require './radio-input-block'
require './screen-size-block'
require './slider-block'
require './text-block'
require './text-input-block'
require './triangle-block'
require './vnet-block'
require './yield-block'
require './stack-block'



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/blocks/index.cjsx